import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { colors, fontSize } from "style";
import Tooltip from "components/Tooltip";

/**
 * RolePipeline
 *
 * @param {Array}    data
 * @param {Array}    tooltipData
 */
const RolePipeline = ({ data, tooltipData }) => (
  <div css={styles.container}>
    {data.map((item, index) => (
      <div key={index} css={styles.item}>
        {tooltipData?.[index] ? (
          <Tooltip key={index} tooltipId={tooltipData[index]} hideIcon>
            {item}
          </Tooltip>
        ) : (
          item
        )}
      </div>
    ))}
  </div>
);

const styles = {
  container: css`
    font-weight: 500;
    font-size: ${fontSize.xxsmall};
    border-radius: 2rem;
    white-space: nowrap;
    display: flex;
    overflow: hidden;
    width: 15rem;
  `,
  item: css`
    flex: 1;
    text-align: center;
    padding: 0.5rem 1rem;
    color: ${colors.darkGreen};
    background: ${colors.green2};

    &:first-of-type {
      background: ${colors.green6};
      font-weight: 400;
    }

    &:nth-of-type(2) {
      background: ${colors.green5};
      font-weight: 500;
    }

    &:nth-of-type(3) {
      background: ${colors.green4};
      font-weight: 600;
    }

    &:nth-of-type(4) {
      background: ${colors.green3};
      font-weight: 700;
    }

    &:nth-of-type(5) {
      font-weight: 700;
    }
  `,
};

RolePipeline.propTypes = {
  data: PropTypes.array,
  tooltipData: PropTypes.array,
};

export default RolePipeline;
